import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea, Box } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

export default function ServiceCard(props) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Card
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        maxWidth: 280,
        background: "white",
        borderRadius: "12px",
        boxShadow: "0px 12px 40px rgba(0, 0, 0, 0.1)",
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, rgba(3, 169, 244, 0.05) 0%, rgba(2, 119, 189, 0.05) 100%)",
          opacity: 0,
          transition: "opacity 0.4s ease",
        },
        "&:hover": {
          transform: "translateY(-12px) scale(1.02)",
          boxShadow: "0px 24px 60px rgba(2, 119, 189, 0.25)",
          "&::before": {
            opacity: 1,
          }
        },
      }}
    >
      <CardActionArea sx={{ padding: "20px" }}>
        <Box
          sx={{
            width: "100%",
            height: "160px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #fff5f0 0%, #ffe8db 100%)",
            borderRadius: "8px",
            marginBottom: "20px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <CardMedia
            component="img"
            src={props.img_}
            sx={{ 
              width: "80%",
              height: "80%",
              objectFit: "contain",
              transition: "transform 0.4s ease",
              transform: isHovered ? "scale(1.1) rotate(5deg)" : "scale(1)",
              filter: "drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.1))",
            }}
            alt={props.title}
          />
        </Box>
        <CardContent sx={{ padding: "0 8px 16px 8px" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
            <Typography
              component="div"
              fontFamily="Montserrat"
              fontSize="16px"
              fontWeight={700}
              lineHeight="1.4"
              letterSpacing="0.02em"
              textTransform="uppercase"
              color="#1a1a2e"
              sx={{
                flex: 1,
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {props.title}
            </Typography>
            <ArrowForward 
              sx={{ 
                color: "#0277BD",
                fontSize: "24px",
                transition: "transform 0.3s ease",
                transform: isHovered ? "translateX(5px)" : "translateX(0)",
              }} 
            />
          </Box>
          <Typography
            variant="body2"
            fontFamily="Montserrat"
            fontSize="13px"
            fontWeight={400}
            lineHeight="1.6"
            letterSpacing="0.01em"
            color="#4a5568"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {props.desc}
          </Typography>
          <Box
            sx={{
              width: "40px",
              height: "4px",
              background: "linear-gradient(90deg, #03A9F4, #0277BD)",
              borderRadius: "2px",
              marginTop: "16px",
              transition: "width 0.3s ease",
              ...(isHovered && { width: "60px" })
            }}
          />
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
